import React, {useState} from 'react';
import { observer } from 'mobx-react'
import '../index.css';
import GlobalState, { changepopupcloseShedule} from "../../../stores/GlobalState";
import Domen from "../../../stores/Domen";
import lang from "../../../lang"

const PopupDeleteWorkspace = observer(() =>{


   
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    const changesegmentationpage0 = () =>{
        // changepopupCloseSelectAttribute();
        // changesegmentationpage(2)
        location.href = location.href
    }
    return (
        <div className="popupInfofon ">
            <div className="popupInfo deleteProduct" style={{height: 'calc(420px - 92px)'}}>
                <div className='top-element'>
                    {/* <div className='separator'></div> */}
                    <div></div>
                    <div className='buttonspopup'>
                        <div className='buttonexit' onClick={changepopupcloseShedule}>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.7891 5.27441L6.24236 18.181" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M6.06055 5.45312L18.9671 17.9998" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='form-element'>
                    <div className='titlePopupDelete'>
                       Are You sure that you want to <br/><span>to close the schedule settings<br/>without saving?</span>
                        
                    </div>
                    <div className='buttonsPopupDelete'>
                        <div className='buttonPopupDelete_select' onClick={changepopupcloseShedule}>
                            {langv?.groupsettings?.popupdeleteproduct?.text2}
                        </div>
                        <div className='buttonPopupDelete_select active' onClick={() =>changesegmentationpage0()}>
                            {langv?.groupsettings?.popupdeleteproduct?.text3}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PopupDeleteWorkspace;
